// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---node-modules-gatsby-plugin-offline-app-shell-js": require("gatsby-module-loader?name=component---node-modules-gatsby-plugin-offline-app-shell-js!/home/bojan/www/preset/preset/website/node_modules/gatsby-plugin-offline/app-shell.js"),
  "component---src-pages-404-js": require("gatsby-module-loader?name=component---src-pages-404-js!/home/bojan/www/preset/preset/website/src/pages/404.js"),
  "component---src-pages-index-js": require("gatsby-module-loader?name=component---src-pages-index-js!/home/bojan/www/preset/preset/website/src/pages/index.js")
}

exports.json = {
  "layout-index.json": require("gatsby-module-loader?name=path---!/home/bojan/www/preset/preset/website/.cache/json/layout-index.json"),
  "offline-plugin-app-shell-fallback.json": require("gatsby-module-loader?name=path---offline-plugin-app-shell-fallback!/home/bojan/www/preset/preset/website/.cache/json/offline-plugin-app-shell-fallback.json"),
  "404.json": require("gatsby-module-loader?name=path---404!/home/bojan/www/preset/preset/website/.cache/json/404.json"),
  "index.json": require("gatsby-module-loader?name=path---index!/home/bojan/www/preset/preset/website/.cache/json/index.json"),
  "404-html.json": require("gatsby-module-loader?name=path---404-html!/home/bojan/www/preset/preset/website/.cache/json/404-html.json")
}

exports.layouts = {
  "layout---index": require("gatsby-module-loader?name=component---src-layouts-index-js!/home/bojan/www/preset/preset/website/.cache/layouts/index.js")
}


// WEBPACK FOOTER //
// ./.cache/async-requires.js